import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let basicExample = `name="Julian"

cat <<EOF
Hello, $name!
Today is $(date +%A).
EOF`

let tabExample = `deploy() {
    cat <<-EOF
	This block can be indented with tabs
	to match the surrounding code, and the
	leading tabs are stripped from the output.
	EOF
}`

let quotedExample = `cat <<'EOF'
Nothing is expanded here: $name and $(date) print literally.
EOF`

let hereStringExample = `grep "127.0.0.1" <<< "$log_line"

# Equivalent to
echo "$log_line" | grep "127.0.0.1"`

export default function Heredocs() {
    return (
        <div className={globalStyles.article}>
            <h1>Here-docs & here-strings</h1>
            <p>A here-doc feeds multi-line text to a command's stdin without a separate file; a here-string
                does the same for a single value.</p>

            <h3>Basic here-doc</h3>
            <p>Variables and command substitution expand by default, just like double-quoted strings.</p>
            <SyntaxHighlighter
                children={basicExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>&lt;&lt;- strips leading tabs</h3>
            <p>Use <code>{"<<-"}</code> instead of <code>{"<<"}</code> to let the heredoc body be indented with
                tabs (not spaces) so it can match the surrounding code.</p>
            <SyntaxHighlighter
                children={tabExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Quote the delimiter to disable expansion</h3>
            <p>Wrapping the opening delimiter in quotes (<code>{"<<'EOF'"}</code>) treats the body as a raw
                literal — handy for printing a template that itself contains <code>$</code> signs.</p>
            <SyntaxHighlighter
                children={quotedExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Here-strings ({"<<<"})</h3>
            <p>A one-line shortcut for piping a single string into a command's stdin.</p>
            <SyntaxHighlighter
                children={hereStringExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
